var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#38424B;}\n\t.st0x{fill:#F28500;}\n\t.st1{fill:none;stroke:#38424B;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#38424B;stroke-width:4.252;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0x",
    points: "266.6,176.9 256.5,156.7 244.8,176.6 234.6,142.9 216.1,166.2 216.1,147.3 157.4,187.1  165.6,157.8 52.8,251.3 46.2,249.6 34.3,282.6 23.6,264.9 39.8,223.9 50.4,228.5 186.1,107.8 198.7,127.9 215.2,124.7  217.9,115.3 231.8,116.1 237.6,98.4 261.5,111.8 274.1,153.8 364.8,219.4 377.1,267.2 368.2,285.4 354.5,236.4  "
  })), /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.2,200.5c0-98.7-80-178.7-178.7-178.7s-178.7,80-178.7,178.7c0,98.7,80,178.7,178.7,178.7 S379.2,299.2,379.2,200.5z M200.5,10.8c104.7,0,189.7,84.9,189.7,189.7c0,104.7-84.9,189.7-189.7,189.7 c-104.8,0-189.7-84.9-189.7-189.7C10.8,95.8,95.8,10.8,200.5,10.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.5,21.8c-98.7,0-178.7,80-178.7,178.7c0,98.7,80,178.7,178.7,178.7s178.7-80,178.7-178.7 C379.2,101.8,299.2,21.8,200.5,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.5,10.8C95.8,10.8,10.8,95.8,10.8,200.5c0,104.7,84.9,189.7,189.7,189.7 c104.7,0,189.7-84.9,189.7-189.7C390.2,95.8,305.2,10.8,200.5,10.8z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.5,
    cy: 200.5,
    r: 196.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoW);
export default __webpack_public_path__ + "static/media/logo_w.5458b70e518a353c9e32b256ee21f7d6.svg";
export { ForwardRef as ReactComponent };